import { useSelector } from 'react-redux';

import type { RootState } from '../../../store';

export const useShowOreaAuthDialog = () => {
  const dialogStatus = useSelector((state: RootState) => state.globalState.oreaDialogStatus);
  return { show: dialogStatus === 'pending', isLoading: false };
};
